/* eslint-disable rulesdir/no-raw-document */
/* eslint-disable rulesdir/no-raw-window */

const ssrDocument = {
  body: {},
  addEventListener() {},
  removeEventListener() {},
  activeElement: {
    blur() {},
    nodeName: "",
  },
  querySelector() {
    return null
  },
  querySelectorAll() {
    return []
  },
  getElementById() {
    return null
  },
  getElementsByClassName() {
    return null
  },
  createEvent() {
    return {
      initEvent() {},
    }
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName() {
        return []
      },
    }
  },
  createElementNS() {
    return {}
  },
  importNode() {
    return null
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: "",
  },
}

const ssrWindow = {
  document: ssrDocument,
  screen: {
    width: null,
    querySelector() {
      return null
    },
  },
  navigator: {
    userAgent: "",
    language: "",
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: "",
  },
  history: {
    replaceState() {},
    pushState() {},
    go() {},
    back() {},
  },
  matchMedia() {},
  addEventListener() {},
  removeEventListener() {},
  localStorage: {
    getItem() {},
    setItem() {},
  },
  sessionStorage: {
    getItem() {},
    setItem() {},
  },
  crypto: {
    getRandomValues() {},
  },
  google: {
    maps: {
      Size: function Size(width, height) {
        this.width = width
        this.height = height
      },
      Geocoder: function Geocoder() {
        // this.geocode = jest.fn()
      },
      LatLng: function LatLng() {
        // this.LatLng = jest.fn()
      },
      Marker: function Marker() {},
      Map: function Map() {
        this.setMapTypeId = function setMapTypeId() {}
        this.mapTypes = {
          set: function set() {},
        }
        this.setCenter = function setCenter() {}
        this.setZoom = function setZoom() {}
        this.panBy = function panBy() {}
      },
      StyledMapType: function StyledMapType() {},
      places: {
        AutocompleteService: function AutocompleteService() {},
        AutocompleteSessionToken: function AutocompleteSessionToken() {},
        PlacesService: function PlacesService() {},
      },
    },
  },
}

let cachedWindow = null

/**
 * Retrieves the global `window` object if it is available, otherwise returns a server-side safe object.
 *
 * @returns {object} The global `window` object if running in a browser environment, or a server-side safe object if running on the server.
 */
export const getWindow = () => {
  // Update the cached window object with the real window object if it's available
  if (typeof window !== "undefined") {
    cachedWindow = window
  }
  // Update the cached window object with the server-side window object if it's not already set
  else {
    cachedWindow = ssrWindow
  }

  /*
   * Return the cached window object. This is to prevent multiple instances
   * of the window object and avoid memory leaks/circular dependencies.
   */
  return cachedWindow
}
